module.exports = __webpack_public_path__ + "static/img/压路机-B声光报警.c0b6fa0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type1-3-model/压路机-B声光报警.png
// module id = Ka6v
// module chunks = 0